export const GET_VEHICLES_BULK_CLUSTER = "GET_VEHICLES_BULK_CLUSTER";
export const GET_VEHICLES_BULK_CLUSTER_SUCCESS = "GET_VEHICLES_BULK_CLUSTER_SUCCESS";
export const GET_VEHICLES_BULK_CLUSTER_ERROR = "GET_VEHICLES_BULK_CLUSTER_ERROR";

export const POST_BULK_CLUSTER = "POST_BULK_CLUSTER";
export const POST_BULK_CLUSTER_SUCCESS = "POST_BULK_CLUSTER_SUCCESS";
export const POST_BULK_CLUSTER_ERROR = "POST_BULK_CLUSTER_ERROR";